export default {
  english: 'aktiv-grotesk, sans-serif',
  jpRegular: 'a-otf-gothic-bbb-pr6n, sans-serif',
  jpMedium: 'aktiv-grotesk, sans-serif',
  jpBold: 'a-otf-midashi-go-mb31-pr6n, sans-serif',
};
